/**
 * * end of cart upsell block part
 */
$(document).ready(function () {
  const amountFreeProduct = document.querySelector('[data-treshold-product]') ? document.querySelector('[data-treshold-product]').getAttribute('data-treshold-product') : null

  var cart_total = $(".gb-totals-total-value").first().text();
  if (amountFreeProduct > 0 && show_progress_bar) {
    /*GB! free product added STARTS*/
    setTimeout(function () {
      var cart_total = $(".gb-totals-total-value").first().text();
      if (cart_total >= amountFreeProduct) {
        if ($(".cart-item").hasClass("gb-find-remove-product")) {
          console.log("Free product already in cart");
        } else {
          console.log("Adding free product");
          $(".gb-free-product-trigger").trigger("click");
        }
      } else {
        console.log("Removing free product - under threshold");
        $(".gb-remove-product").trigger("click");
      }
    }, 3000);
    $("body").on("click", ".gb-sumbit-free", function () {
      setTimeout(function () {

        if (cart_total >= amountFreeProduct) {
          if ($(".cart-item").hasClass("gb-find-remove-product")) {
          } else {
            $(".gb-free-product-trigger").trigger("click");
          }
        } else {
          $(".gb-remove-product").trigger("click");
        }
      }, 3000);
    });

    // $("body").on("click", ".shop-add-to-cart-button", function () {
    //   setTimeout(function () {
    //     var cart_total = $(".gb-totals-total-value").first().text();
    //     if (cart_total >= amount_free_product) {
    //       if ($(".cart-item").hasClass("gb-find-remove-product")) {
    //       } else {
    //         $(".gb-free-product-trigger").trigger("click");
    //       }
    //     } else {
    //       $(".gb-remove-product").trigger("click");
    //     }
    //   }, 3000);
    // });
  }

  $("body").on(
    "click",
    ".gb-shipping-protection-button label.switch",
    async (e) => {
      if (e.target.tagName == "INPUT") return;
      const curElem = document.querySelector(
        ".gb-shipping-protection-button label.switch"
      );
      const curInputElem = document.querySelector(
        ".gb-shipping-protection-button label.switch input"
      );
      const spinAnim = document.querySelector(
        ".gb-shipping-protection-button .spin-animation"
      );
      const checkElem = document.querySelector(
        ".gb-shipping-protection-button .complete-check"
      );
      if (curElem.classList.contains("unchecked") && !curInputElem.checked) {
        if (spinAnim.style.display == "block" || curInputElem.checked) return;

        // $(".gb-product-shipping-protection-product-tirgger").trigger("click");
        const form = document.querySelector("form.shipping-protection-form");

        const formData = new FormData(form);
        if (!formData.get("id")) {
          console.error(
            "There is no shipping protection product selected. Please select the shipping product in the global theme settings"
          );
          return;
        }

        spinAnim.style.display = "block";

        try {
          const response = await fetch(routes.cart_add_url, {
            method: "POST",
            body: formData,
            headers: {
              Accept: "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
          });

          if (response.ok) {
            spinAnim.style.display = "none";

            checkElem.style.display = "block";
          }
        } catch (err) {
          console.error("error at shipping protection form submission", err);
        }
        fetch(routes.cart_url + "?view=drawer")
          .then((response) => response.text())
          .then((html) => {
            const cartDrawer = document.querySelector("#CartDrawer");
            const parsedCartHtml = parser.parseFromString(html, "text/html");
            const newCartDrawer = parsedCartHtml.querySelector("#CartDrawer");
            if (cartDrawer && newCartDrawer) {
              updateCartDrawer(cartDrawer, newCartDrawer, true, () => {
                curElem.classList.remove("unchecked");
                curElem.classList.add("checked");
                curInputElem.checked = true;
              });
            }
          })
          .catch((_err) => {
            curElem.classList.remove("unchecked");
            curElem.classList.add("checked");
            curInputElem.checked = true;
          });
      } else if (
        curElem.classList.contains("checked") &&
        curInputElem.checked
      ) {
        checkElem.style.display = "none";
        const cartDrawer = document.querySelector("#CartDrawer");
        const removeButton = cartDrawer.querySelector(
          `cart-remove-button[data-id="${shippingProductId}"]`
        );
        const shippingItemIndex = removeButton?.dataset.index;
        if (!removeButton || !shippingItemIndex) {
          return;
        }

        const cartItems =
          cartDrawer.querySelector("cart-items") ||
          cartDrawer.querySelector("cart-drawer-items");

        const event = new CustomEvent("remove-shipping-protection", {
          detail: null,
        });
        cartItems.updateQuantity(shippingItemIndex, 0, event, "", "", () => {
          curElem.classList.remove("checked");
          curElem.classList.add("unchecked");
          curInputElem.removeAttribute("checked");
        });
      }
    }
  );

  $("body").on("change", ".gb-change-variant_id", function () {
    var id_change = $(this).find(":selected").attr("data-variant-id");
    if (!id_change) {
      console.error("No data-variant-id found on selected option");
      return;
    }
    $(this)
      .closest(".gb-get-main-freq-pro")
      .find(".product-variant-id")
      .val(id_change);
  });
});

document.addEventListener("change", function (e) {
  if (
    e.target.matches(
      ".cart-drawer .gbfrequently-bought-with-main-whole .select__select"
    )
  ) {
    const parentBlock = e.target.closest(".gb-get-main-freq-pro");
    if (!parentBlock) {
      console.log("Error: Could not find parent block");
      return;
    }

    const allValues = Array.from(
      parentBlock.querySelectorAll(".select__select")
    )
      .map((sel) => sel.value)
      .join(" / ");

    const variantSelect = parentBlock.querySelector('[name="variants"]');
    if (!variantSelect) {
      console.log("Error: Could not find variant selector");
      return;
    }

    const matchedOption = Array.from(variantSelect.options).find((option) =>
      option.text.includes(allValues)
    );

    const idInput = parentBlock.querySelector('[name="id"]');
    if (!idInput) {
      console.log("Error: Could not find id input field");
      return;
    }

    if (matchedOption) {
      console.log("Matched variant option value:", matchedOption.value);
      idInput.value = matchedOption.value;
      console.log("Set ID input value to:", idInput.value);
    } else {
      console.log("No matching variant found for:", allValues);
    }
  }
});

// Add validation for form submissions to ensure ID parameter is present
document.addEventListener("submit", function (e) {
  if (e.target.action && e.target.action.includes("/cart/add")) {
    const idInput = e.target.querySelector('[name="id"]');
    if (!idInput || !idInput.value) {
      console.log("Preventing submission - missing id parameter");
      e.preventDefault();
      return false;
    }
  }
});

// Improve cart quantity handlers
$(document).ready(function () {
  // Ensure all cart quantity changes include product ID
  $(".cart-item .quantity__button, .cart-item .quantity__input").on(
    "click change input",
    function () {
      const cartItem = $(this).closest(".cart-item");
      const variantId = $(this)
        .closest(".quantity-input")
        .find(".quantity__input")
        .data("quantity-variant-id");

      // If this is a form submission, ensure the ID is included
      if ($(this).closest("form").length > 0) {
        let idInput = $(this).closest("form").find('input[name="id"]');
        if (idInput.length === 0 && variantId) {
          console.log("Adding missing ID input to cart form");
          $("<input>")
            .attr({
              type: "hidden",
              name: "id",
              value: variantId,
            })
            .appendTo($(this).closest("form"));
        } else if (idInput.length > 0 && variantId) {
          idInput.val(variantId);
        }
      }
    }
  );

  // Add validation for cart drawer checkout button
  $("#CartDrawer-Checkout").on("click", function (e) {
    const form = $("#CartDrawer-Form");
    if (form.length === 0) return;

    // Check if there are any items in the cart
    const cartItems = form.find(".cart-item");
    if (cartItems.length === 0) {
      console.log("No items in cart, preventing checkout");
      e.preventDefault();
      return false;
    }

    console.log("Cart checkout with", cartItems.length, "items");
  });

  /**
   * * Prevent redirecting to checkout when pressing enter at quantity input
   */
  $(document).on("keydown", ".quantity__input", function (e) {
    if (e.key === "Enter" || e.keyCode === 13) {
      e.preventDefault();
      $(this).trigger("blur");
    }
  });
  // * End of handler
});

// Fix for frequently bought products add to cart
$(document).ready(function () {
  // Find all frequently bought product forms or buttons
  $(
    ".gbfrequently-bought-with-main-whole button, .gbfrequently-bought-with-main-whole .gb-sumbit-free, .gb-free-product-trigger, .gb-product-shipping-protection-product-tirgger, .gb-product-sticky-add-to-cart-form"
  ).on("click", function (e) {
    const parentBlock = $(this).closest(".gb-get-main-freq-pro, form");
    if (!parentBlock) {
      console.error(
        "Could not find parent block for frequently bought product"
      );
      return;
    }

    // Find the product ID input or data attribute
    let productId = null;

    // Check for direct ID input
    const idInput = parentBlock.find('input[name="id"]');
    if (idInput.length > 0 && idInput.val()) {
      productId = idInput.val();
    }
    // Check for variant ID on select
    else if (parentBlock.find(".gb-change-variant_id").length > 0) {
      const selectedOption = parentBlock.find(
        ".gb-change-variant_id option:selected"
      );
      if (selectedOption.length > 0) {
        productId = selectedOption.data("variant-id");
      }
    }
    // Check for product-variant-id input
    else if (parentBlock.find(".product-variant-id").length > 0) {
      productId = parentBlock.find(".product-variant-id").val();
    }
    // Check for data attributes on the button itself
    else if ($(this).data("variant-id")) {
      productId = $(this).data("variant-id");
    }

    console.log("Frequently bought product add to cart - ID:", productId);

    if (
      this.classList.contains("gb-free-product-trigger") &&
      !show_progress_bar
    )
      return;

    // If no product ID found, prevent submission
    if (!productId) {
      console.error("Missing product ID for frequently bought product");
      e.preventDefault();
      return false;
    }

    // Update or create the ID input
    if (idInput.length === 0) {
      console.log("Adding missing ID input to frequently bought product form");
      $("<input>")
        .attr({
          type: "hidden",
          name: "id",
          value: productId,
        })
        .appendTo(parentBlock);
    } else {
      idInput.val(productId);
    }

    // Ensure quantity is included
    let quantityInput = parentBlock.find('input[name="quantity"]');
    if (quantityInput.length === 0) {
      console.log(
        "Adding default quantity input to frequently bought product form"
      );
      $("<input>")
        .attr({
          type: "hidden",
          name: "quantity",
          value: 1,
        })
        .appendTo(parentBlock);
    } else if (!quantityInput.val() || quantityInput.val() < 1) {
      quantityInput.val(1);
    }
  });
});
/**
 * Variant Price Sync - Fixes price block updates for variant selector and Kaching subscription
 */
(function() {
  'use strict';
  
  function initPriceSync() {
    const priceBlockElement = document.querySelector('.shop-product-price-block');
    const priceCompareAtPriceElement = document.querySelector('.shop-compare-price');
    const savePriceElement = document.querySelector('.shop-save-price');
    const priceContainer = document.querySelector('.shop-product-price-container');
    
    if (!priceBlockElement) {
      console.warn('Price block element not found');
      return;
    }
    
    // Function to update price display
    function updatePriceDisplay(currentPrice, comparePrice) {
      if (priceBlockElement && currentPrice) {
        priceBlockElement.innerText = currentPrice;
      }
      
      if (priceCompareAtPriceElement && comparePrice) {
        priceCompareAtPriceElement.innerText = comparePrice;
      }
      
      // Update savings badge
      if (savePriceElement) {
        const currentVal = parseFloat(currentPrice.replace(/[^\d.]/g, ''));
        const compareVal = parseFloat(comparePrice.replace(/[^\d.]/g, ''));
        
        if (compareVal && compareVal > currentVal) {
          savePriceElement.style.display = '';
          if (priceContainer) priceContainer.classList.add('on-sale');
          if (priceBlockElement) priceBlockElement.classList.add('on-sale');
          
          const discountPercentage = Math.round(((compareVal - currentVal) / compareVal) * 100);
          const dollarDiscount = Math.round(compareVal - currentVal);
          const displayType = savePriceElement.getAttribute('data-display-type') || 'percentage';
          
          if (displayType !== 'custom_amount') {
            let newValue = displayType === 'dollar_amount' 
              ? '₱' + dollarDiscount 
              : discountPercentage + '%';
            
            let currentHTML = savePriceElement.innerHTML;
            currentHTML = currentHTML.replace(/₱\d+|\d+%/g, newValue);
            savePriceElement.innerHTML = currentHTML;
          }
        } else {
          savePriceElement.style.display = 'none';
          if (priceContainer) priceContainer.classList.remove('on-sale');
          if (priceBlockElement) priceBlockElement.classList.remove('on-sale');
        }
      }
    }
    
    // Check if subscription is active
    function isSubscriptionActive() {
      const kachingCard = document.querySelector('.kaching-subscriptions__checkbox-card-wrapper');
      return kachingCard?.querySelector('.kaching-subscriptions__checked-checkbox') !== null;
    }
    
    // Get subscription prices
    function getSubscriptionPrices() {
      const kachingCard = document.querySelector('.kaching-subscriptions__checkbox-card-wrapper');
      const subscriptionPrice = kachingCard?.querySelector('.ks-discounted-price');
      const subscriptionOriginalPrice = kachingCard?.querySelector('.ks-original-price');
      
      return {
        current: subscriptionPrice?.innerText || '',
        compare: subscriptionOriginalPrice?.innerText || ''
      };
    }
    
    // Get variant prices
    function getVariantPrices() {
      const selectedCard = document.querySelector('.variant-product-card.selected');
      const currentEl = selectedCard?.querySelector('.variant-pricing .variant-current-price');
      const compareEl = selectedCard?.querySelector('.variant-pricing .variant-original-price');
      
      return {
        current: currentEl?.innerText || '',
        compare: compareEl?.innerText || ''
      };
    }
    
    // Sync prices based on current selection
    function syncPrices() {
      let prices;
      
      if (isSubscriptionActive()) {
        // Use subscription prices
        prices = getSubscriptionPrices();
      } else {
        // Use variant prices
        prices = getVariantPrices();
      }
      
      if (prices.current) {
        updatePriceDisplay(prices.current, prices.compare);
      }
    }
    
    // Wait for Kaching to update subscription prices
    function waitForKachingUpdate(callback, maxAttempts = 10) {
      const kachingCard = document.querySelector('.kaching-subscriptions__checkbox-card-wrapper');
      const selectedVariant = document.querySelector('.variant-product-card.selected');
      
      if (!kachingCard || !selectedVariant) {
        callback();
        return;
      }
      
      // Get the variant's base price to compare with subscription
      const variantPrice = selectedVariant.querySelector('.variant-pricing .variant-current-price')?.innerText;
      const subscriptionPrice = kachingCard.querySelector('.ks-original-price')?.innerText;
      
      let attempts = 0;
      
      const checkUpdate = () => {
        attempts++;
        const newSubscriptionPrice = kachingCard.querySelector('.ks-original-price')?.innerText;
        
        // Check if Kaching has updated (subscription original price matches variant price)
        if (newSubscriptionPrice === variantPrice || attempts >= maxAttempts) {
          callback();
        } else {
          setTimeout(checkUpdate, 50); // Check again in 50ms
        }
      };
      
      // If prices don't match, Kaching is still updating
      if (subscriptionPrice !== variantPrice) {
        setTimeout(checkUpdate, 50);
      } else {
        callback();
      }
    }
    
    // Add event listeners to variant cards
    function enhanceVariantCards() {
      const cards = document.querySelectorAll('.variant-product-card');
      
      cards.forEach((card) => {
        card.addEventListener('click', function() {
          // Wait for original click handler to add "selected" class
          setTimeout(() => {
            if (isSubscriptionActive()) {
              // If subscription is active, wait for Kaching to update
              waitForKachingUpdate(() => {
                syncPrices();
              });
            } else {
              // No subscription, sync immediately
              syncPrices();
            }
          }, 10);
        });
      });
    }
    
    // Monitor Kaching subscription changes
    function initKachingSync() {
      const kachingWrapper = document.querySelector('.kaching-subscriptions__cards-wrapper');
      if (!kachingWrapper) return;
      
      let isUpdating = false;
      
      const observer = new MutationObserver(() => {
        if (isUpdating) return;
        isUpdating = true;
        
        setTimeout(() => {
          syncPrices();
          isUpdating = false;
        }, 100);
      });
      
      observer.observe(kachingWrapper, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
      
      // Handle clicks on Kaching wrapper
      kachingWrapper.addEventListener('click', () => {
        setTimeout(() => {
          syncPrices();
        }, 150);
      });
    }
    
    // Wait for original script to initialize
    setTimeout(() => {
      enhanceVariantCards();
      initKachingSync();
      
      // Trigger initial sync
      syncPrices();
    }, 500);
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPriceSync);
  } else {
    initPriceSync();
  }
})();